import React from "react";
import PropTypes from "prop-types";

// Open-box proof photos for one delivery
// (`.scratch/logistics-dashboard/IMPLEMENTATION.md` §11).
//
// Read-only viewer: the photos are captured in the Create Delivery modal and cannot be
// changed once the shipment is booked — this is evidence, not an editable field.
//
// URLs come from `deliveryBoxImageUrls`, resolved server-side in Delivery.Get. They are
// SAS-signed and expire, which is why the row also carries the stable blob names and why
// nothing here caches or persists a URL.
function BoxImagesModal({ delivery, onClose }) {
    const urls = delivery?.deliveryBoxImageUrls || [];

    return (
        <div className="flex flex-col gap-[0.9rem] min-w-[420px] max-w-[640px]">
            <div className="flex justify-between items-center">
                <span className="text-[1.5rem] font-bold">Open Box Photos</span>
                <span className="text-[1.2rem]">
                    Delivery ID: <span className="text-[1.2rem] font-semibold">{`#${delivery?.id}`}</span>
                </span>
            </div>
            <hr />

            {urls.length === 0 ? (
                // Reachable if the SAS resolution failed even though names exist — say that,
                // rather than showing an empty box that reads as "no photos were taken".
                <p className="text-[1.2rem] text-gray-500">
                    Photos are recorded for this delivery but could not be loaded right now.
                </p>
            ) : (
                <div className="flex flex-col gap-3 max-h-[60vh] overflow-y-auto pr-1">
                    {urls.map((url, index) => (
                        <figure key={url} className="flex flex-col gap-1">
                            <img
                                src={url}
                                alt={`Open box ${index + 1} of ${urls.length}`}
                                className="w-full rounded-lg border border-gray-200 object-contain"
                            />
                            <figcaption className="flex justify-between text-sm text-gray-500">
                                <span>{`Photo ${index + 1} of ${urls.length}`}</span>
                                <a href={url} target="_blank" rel="noreferrer" className="text-[#00A48B]">
                                    Open full size
                                </a>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            )}

            <div className="flex justify-end">
                <button
                    type="button"
                    onClick={onClose}
                    className="px-5 py-2 rounded-xl border border-gray-300 text-[1.2rem] font-semibold text-gray-700 hover:bg-gray-50"
                >
                    Close
                </button>
            </div>
        </div>
    );
}

BoxImagesModal.propTypes = {
    delivery: PropTypes.object,
    onClose: PropTypes.func.isRequired,
};

export default BoxImagesModal;
